<template>
    <div class="table-box">
        <Form ref="search" :model="formItem" :label-width="100" label-colon="：">
            <Row>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="发票号码">
                        <Input v-model="formItem.invoiceNum"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="发票代码">
                        <Input v-model="formItem.invoiceCode"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 24}" :xl="{ span: 12}" class="mb-10 text-right">
                    <Button type="primary" @click="getInvoiceList()">搜索</Button>
                    <Button style="margin-left: 8px" @click="clearSearch()">清空</Button>
                </Col>
            </Row>
        </Form>
        <div ref="showTable" class="table-detail">
            <Table :columns="columns" :data="tableData" :height="THeight" :loading="loading" border></Table>
        </div>
        <div ref="page" class="table-page"><Page :current="page" :page-size="limit" :total="total" show-sizer @on-change="pagechange($event)" @on-page-size-change="pageNumchange($event)" /></div>
    </div>
</template>
<script>
import api from '@/api/index';
import { timestampToYMD } from '@/assets/js/utils';
export default {
    data() {
        return {
            columns: [
                {
                    title: '发票号码',
                    key: 'invoiceNum'
                },
                {
                    title: '发票代码',
                    key: 'invoiceCode'
                },
                {
                    title: '填入用户',
                    align: 'username',
                    width: '110',
                    render: (h, params) => {
                        return h('div', params.row.username);
                    }
                },
                {
                    title: '所属公司',
                    key: 'deptName',
                    align: 'center',
                    width: '130'
                },
                {
                    title: '录入时间',
                    key: 'createTime',
                    align: 'center',
                    width: '170'
                },
                {
                    title: '开票日期',
                    key: 'invoicingDate',
                    align: 'center',
                    width: '120',
                    render: (h, params) => {
                        let date = timestampToYMD(params.row.invoicingDate);
                        return h('div', date);
                    }
                },
                {
                    title: '校验码',
                    key: 'checkCode',
                    minWidth: 120
                },
                {
                    title: '金额',
                    key: 'money'
                },
                {
                    title: '发票类型',
                    key: 'invoiceType',
                    align: 'center',
                    width: '120',
                    render: (h, params) => {
                        let name = '';
                        if (params.row.invoiceType === '0') {
                            name = '采购';
                        } else if (params.row.invoiceType === '1') {
                            name = '销售';
                        }
                        return h('div', name);
                    }
                },
                {
                    title: '备注',
                    key: 'description'
                }
            ],
            tableData: [],
            formItem: {
                invoiceNum: '',
                invoiceCode: ''
            },
            THeight: 100,
            page: 1,
            limit: 20,
            total: 0,
            timer: '',
            loading: true
        };
    },
    mounted() {
        this.fixedTable();
        this.windowOnresize();
        this.getInvoiceList();
    },
    methods: {
        fixedTable() {
            const pTop = this.$refs.search.$el.clientHeight;
            const pBottom = this.$refs.page.clientHeight;
            this.$refs.showTable.style.top = pTop + 'px';
            this.$refs.showTable.style.bottom = pBottom + 'px';
            this.THeight = this.$refs.showTable.clientHeight - 10;
        },
        windowOnresize() {
            window.onresize = () => {
                window.clearTimeout(this.timer);
                this.$refs.showTable.style.overflow = 'hidden';
                return (() => {
                    this.timer = setTimeout(() => {
                        this.fixedTable();
                        this.$refs.showTable.style.overflow = 'visible';
                    }, 100);
                })();
            };
        },
        async getInvoiceList() {
            this.loading = true;
            const res = await api.getInvoiceList(this.formItem.invoiceNum, this.formItem.invoiceCode, this.limit, this.page);
            if (res.code !== 200) {
                return;
            }
            this.total = res.data.total;
            this.tableData = res.data.resultList;
            this.loading = false;
        },
        clearSearch() {
            this.formItem.invoiceNum = '';
            this.formItem.invoiceCode = '';
            this.getInvoiceList();
        },
        pagechange(num) {
            this.page = num;
            this.getInvoiceList();
        },
        pageNumchange(num) {
            this.limit = num;
            this.getInvoiceList();
        }
    }
};
</script>

<style lang="scss" scoped>
.table-box {
    height: 100%;
    overflow: hidden;
    position: relative;
}
.table-detail {
    position: absolute;
    left: 0;
    right: 0;
}
.table-page {
    position: absolute;
    bottom: 0;
}
</style>
<style scoped>

.table-box >>> .ivu-form-item {
    margin-bottom: 10px;
}
</style>
